import { createSlice } from '@reduxjs/toolkit'

export const sessionSlice = createSlice({
	name: 'auth/session',
	initialState: {
		accessToken: '',
		refreshToken: '',
        signedIn: false,
    },
	reducers: {
        onSignInSuccessAdmin: (state, action) => {
            state.signedIn = true
			state.accessToken = action.payload.accessToken
			state.refreshToken = action.payload.refreshToken
        },
        onSignOutSuccessAdmin: (state) => {
            state.signedIn = false
			state.accessToken = ''
			state.refreshToken = ''
        },
        setTokenAdmin: (state, action) =>  {
			state.accessToken = action.payload.access_token
			state.refreshToken = action.payload.refresh_token
        }
	},
})

export const { onSignInSuccessAdmin, onSignOutSuccessAdmin, setTokenAdmin } = sessionSlice.actions

export default sessionSlice.reducer
